import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/DashboardLayout';
import Login from './pages/Login';
import DashboardHome from './pages/DashboardHome';
import Hosts from './pages/Hosts';
import Templates from './pages/Templates';
import AdminUsers from './pages/AdminUsers';
import Subscriptions from './pages/Subscriptions';
import Championships from './pages/Championships';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Messages from './pages/Messages';
import Pricing from './pages/Pricing';
import Coupons from './pages/Coupons';
import AIQuestionGenerator from './pages/AIQuestionGenerator';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected Admin Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardHome />} />
            <Route path="hosts" element={<Hosts />} />
            <Route path="templates" element={<Templates />} />
            <Route path="admin-users" element={<AdminUsers />} />
            <Route path="subscriptions" element={<Subscriptions />} />
            <Route path="championships" element={<Championships />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="settings" element={<Settings />} />
            <Route path="messages" element={<Messages />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="coupons" element={<Coupons />} />
            <Route path="/dashboard/ai-generator" element={<AIQuestionGenerator />} />
          </Route>
          {/* Redirect root to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          {/* 404 - Redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
